import { getApiBaseUrl } from "../utils/apiConfig";

export const login = async (email, password) => {
  try {
    const apiUrl = getApiBaseUrl();
    const response = await fetch(`${apiUrl}/users/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }

    // Store the token
    if (data.token) {
      localStorage.setItem("jwt_token", data.token);

      try {
        const parts = data.token.split(".");
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]));
          localStorage.setItem("user", JSON.stringify(payload));
        } else if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        }
      } catch (e) {
        if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        }
      }
    }

    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const googleLogin = async (idToken) => {
  try {
    const apiUrl = getApiBaseUrl();
    const response = await fetch(`${apiUrl}/users/google-login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idToken }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Google login failed');
    }

    // Store the token
    if (data.token) {
      localStorage.setItem("jwt_token", data.token);

      try {
        const parts = data.token.split(".");
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]));
          localStorage.setItem("user", JSON.stringify(payload));
        } else if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        }
      } catch (e) {
        if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        }
      }
    }

    return data;
  } catch (error) {
    console.error('Google login error:', error);
    throw error;
  }
};